import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { DevTools } from "jotai-devtools";
import "jotai-devtools/styles.css";

export const Route = createRootRoute({
	component: RootPage,
});

export function RootPage() {
	return (
		<>
			{import.meta.env.DEV && (
				<>
					<TanStackRouterDevtools />
					<ReactQueryDevtools />
					<DevTools />
				</>
			)}
			<Outlet />
		</>
	);
}
